import { Component, ElementRef, EventEmitter, Input, Output, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { TabComponent } from '../../../components/tab/tab.component';
import { ApprovalFlowComponent } from '../../../components/approval-flow/approval-flow.component';
import { AccionIcon } from '../../../components/tab/tab.interface';
import { faEdit } from '@fortawesome/pro-light-svg-icons';
import { TableComponent } from '../../../components/table/table.component';
import { RespuestaFlujoAprobacion } from '../../../interfaces/flujo-aprobacion.interface';
import { CommonModule } from '@angular/common';
import { TableConfig } from '../../../components/table/table-config.interface';
import { HelpersService } from '../../../services/helpers.service';
import { AprobacionService } from '../../../services/aprobacion.service';
import { RespuestaPresupuestoRecurso } from '../../../interfaces/presupuesto-recurso.interface';
import { RespuestaPresupuestoCuentaCosto } from '../../../interfaces/presupuesto-cuenta-costo.interface';
import { PopoverComponent } from '../../../components/popover/popover.component';

@Component({
  selector: 'contenido-flujo',
  standalone: true,
  imports: [TabComponent, ApprovalFlowComponent, TableComponent, CommonModule, PopoverComponent],
  templateUrl: './contenido-flujo.component.html',
  styleUrl: './contenido-flujo.component.scss'
})
export class ContenidoFlujoComponent {
  
  @Output() clickEditFlow = new EventEmitter<any>();
  @Input() flujoAprobacion:any;
  @Input() dataDetail:any;

  @ViewChild('tab1TemplateFlow') tab1TemplateFlow!: TemplateRef<any>;
  @ViewChild('tab2TemplateFlow') tab2TemplateFlow!: TemplateRef<any>;
  @ViewChild('tab3TemplateFlow') tab3TemplateFlow!: TemplateRef<any>;

  tabsFlujos = [
    { name: 'tab1', label: 'Aprobación' },
    { name: 'tab2', label: 'Presupuesto por recurso' },
    { name: 'tab3', label: 'Presupuesto por cuenta de costo' }
  ];

  accionIconRightTblFlujo: AccionIcon[] = [
    {
      icon:faEdit,
      titleToltip: "Editar Flujo de Aprobación",
      name:"Flujo",
      positionToltip:"bottom-right"
    }
  ];
  accionIconLeftTblFlujo: AccionIcon[] = [];

  dataConfigListCheck:TableConfig =  {
    config: [
      { header: 'Código', key: 'cod'},
      { header: 'Descripción', key: 'descripcion'},
      { header: 'Cantidad', key: 'cantidad'},
      { header: 'Unidad de medida', key: 'unidad'},
      { header: 'Precio Unitario', key: 'DescripcionDocumentoNroDocumento'},
      { header: 'Precio total', key: 'FechaCreacionFormato'},
      { header: 'Comprado', key: 'xml'},
      { header: 'Por comprar', key: 'CantidadAdjuntos'}
    ],
    accion: [],
    name: "usuario",
    nameMensageTable: "direcciones",
    initialMessage: {
      active: false,
      message: "hola"
    },
    delete: false
  };
  
  dataListadoRecurso ={
    listTable: [] as RespuestaPresupuestoRecurso[],
    isOpen: false
  };

  dataConfigPresupuestoRecurso:TableConfig =  {
    config: [
      { header: 'Código', key: 'Codigo'},
      { header: 'Descripción', key: 'Descripcion'},
      { header: 'Cantidad', key: 'CantidadPresupuestada'},
      { header: 'Unidad de medida', key: 'IdUOMCliente'},
      { header: 'Precio Unitario', key: 'PrecioUnitarioPresupuestado'},
      { header: 'Presio total', key: 'PrecioTotalPresupuestado'},
      { header: 'Comprado', key: 'CantidadComprada'},
      { header: 'Por comprar', key: 'CantidadPorComprar'}
    ],
    accion: [],
    name: "usuario",
    nameMensageTable: "Presupuesto por recurso",
    initialMessage: {
      active: false,
      message: "hola"
    },
    delete: false,
    MensageSimple:true,
    isTitleTable: true
  };

  dataConfigPresupuestoCuenta:TableConfig =  {
    config: [
      { header: 'Cuenta de costo', key: 'cod'},
      { header: 'Descripción', key: 'descripcion'},
      { header: 'Presupuesto', key: 'cantidad'},
      { header: 'Comprado', key: 'unidad'},
      { header: 'Facturado sin OC', key: 'DescripcionDocumentoNroDocumento'},
      { header: 'Recibido', key: 'FechaCreacionFormato'}],
    accion: [],
    name: "usuario",
    nameMensageTable: "Presupuesto por cuenta de costo",
    initialMessage: {
      active: false,
      message: "hola"
    },
    delete: false,
    MensageSimple:true
  };
  
  dataListadoCuenta ={
    listTable: [] as RespuestaPresupuestoCuentaCosto[],
    isOpen: false
  };

  primeraVezPrecupuestoCuenta:boolean = true;
  primeraVezPrecupuestoRecurso:boolean = true;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['flujoAprobacion']) {
      this.flujoAprobacion = changes['flujoAprobacion'].currentValue;
    }
    if (changes['dataDetail']) {
      this.dataDetail =  changes['dataDetail'].currentValue;
    }

  }

  editFlujo(evt:any){
    this.clickEditFlow.emit(evt);
  }


  constructor(private helpersServices: HelpersService, private aprobacionService: AprobacionService) {
    
  }

  clickTabFlujo(event: any){
    if(event == "tab2"){
      if(this.primeraVezPrecupuestoRecurso){
        this.primeraVezPrecupuestoRecurso = false;
        this.getPresupuestoPorRecurso();
      }
    }else if(event == "tab3"){
      if(this.primeraVezPrecupuestoCuenta){
        this.primeraVezPrecupuestoCuenta = false;
        this.getPresupuestoPorRecurso();
      }
    }
  }

  getPresupuestoPorCuenta(){
    this.aprobacionService.ObtenerPresupuestoPorCuentaCosto(parseInt(this.dataDetail.idOrgc), parseInt(this.dataDetail.idDoc)).subscribe({
      next: (response: RespuestaPresupuestoCuentaCosto[]) => {
        this.dataListadoCuenta.listTable = response;
      },
      error: (error) => {
        console.error('Error: Listador presupuesto cuenta');
      }
    });
  }

  getPresupuestoPorRecurso(){
    this.aprobacionService.ObtenerPresupuestoPorRecurso(parseInt(this.dataDetail.idOrgc), parseInt(this.dataDetail.idDoc)).subscribe({
      next: (response: RespuestaPresupuestoRecurso[]) => {
        this.dataListadoRecurso.listTable = response;
      },
      error: (error) => {
        console.error('Error: Listador presupuesto recurso');
      }
    });
  }

  isPopoverVisible: boolean = false;
  popoverTop: number = 0;
  popoverLeft: number = 0;

  @ViewChild('triggerButton', { static: false }) triggerButton!: ElementRef;

  togglePopover(): void {
    if (!this.isPopoverVisible) {
      const rect = this.triggerButton.nativeElement.getBoundingClientRect();
      this.popoverTop = rect.bottom; // Calcula la posición vertical
      this.popoverLeft = rect.left; // Calcula la posición horizontal
    }
    this.isPopoverVisible = !this.isPopoverVisible;
  }

  closePopover(): void {
    this.isPopoverVisible = false;
  }
  
}
